"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.date.today': 'Oggi',
    'conversations.date.yesterday': 'Ieri',
    'conversations.date.daysAgo': '{days} giorni fa',
};
